import { SignatureCard } from '@common/SignatureCard';
import { FormFieldMethods, FormTextarea, Grid, Label } from '@gcl/react-core';
import { IProjectTransmittal } from '@transmittal/transmittal.models';
import * as React from 'react';
import { ETransmittalStatus } from '@transmittal/transmittal.constants';
import { ETransmittalDetailsFormKeys } from './transmittalDetailPage.constants';

interface ITransmittalDetailEndorsementProps {
  formFieldMethods: FormFieldMethods;
  transmittalDetails?: IProjectTransmittal | null;
  remarkRequired?: boolean;
  signatureLabel?: string;
  isReadOnly?: boolean;
}
export const TransmittalDetailEndorsement: React.FunctionComponent<ITransmittalDetailEndorsementProps> = ({
  formFieldMethods,
  transmittalDetails,
  remarkRequired = false,
  signatureLabel = undefined,
  isReadOnly,
}) => {
  const approvedBy = transmittalDetails?.approvedByProjectUserProfile?.userProfile?.displayName;
  const approvedDate = transmittalDetails?.approvedDate;
  const signProfile = transmittalDetails?.approvedByProjectUserProfile?.userProfile?.signatureUserProfile;

  return (
    <div className="gcl-gems-transmittal-detail-endorsement-container">
      <SignatureCard
        className="gcl-gems-transmittal-detail-endorsement-card"
        title="Endorsement"
        signProfile={signProfile}
        signUser={approvedBy?.toString()}
        signDate={approvedDate}
        onRenderContent={(signatureComponent) => {
          return (
            <Grid container alignItems="top" wrap="nowrap">
              <Grid item flexGrow={1}>
                <div className="gcl-gems-transmittal-detail-endorsement-remark-container">
                  <Label labelFor={ETransmittalDetailsFormKeys.REMARK} required={remarkRequired}>
                    Remark
                  </Label>
                  <FormTextarea
                    rules={
                      remarkRequired
                        ? {
                            required: {
                              value: true,
                              message: 'This field is required',
                            },
                          }
                        : {}
                    }
                    formFieldMethods={formFieldMethods}
                    id={ETransmittalDetailsFormKeys.REMARK}
                    className="gcl-gems-transmittal-detail-endorsement-remark"
                    disabled={!!approvedBy || isReadOnly}
                  />
                </div>
              </Grid>
              {transmittalDetails?.status === ETransmittalStatus.APPROVED && signatureComponent ? (
                <Grid item xs={6}>
                  <div className="gcl-gems-transmittal-detail-endorsement-approved-container">
                    {signatureLabel ? <Label labelFor="endorsement-signature">{signatureLabel}</Label> : undefined}
                    {signatureComponent}
                  </div>
                </Grid>
              ) : undefined}
            </Grid>
          );
        }}
      />
    </div>
  );
};
